<button
  id="onsip--user-settings"
  mat-raised-button
  color="primary"
  (click)="openPasswordChangeDialog()"
>
  {{ "ONSIP_I18N.RESET_WEB_PASSWORD" | translate }}
</button>
